import { useMemo } from 'react';

import ApiCalls from '../../components/api/apiCalls';
import TaskStatusesService from '../../components/services/TaskStatusesService';

const useTaskStatusesService = () => {
  return useMemo(() => new TaskStatusesService(new ApiCalls()), []);
};

export default useTaskStatusesService;
